<template>
  <div class="outerbg">
    <div class="bg">
      <h2>身份信息确认</h2>
      <p>
        *请您将面部清晰地保持在识别区域中央然后点击提交按钮<br />*提交识别后需要短暂时间,请耐心等待
      </p>
      <div class="con">
        <div class="page-record-video">
          <video
            autoplay="autoplay"
            muted="muted"
            class="page-record-video-obj"
          ></video>
          <i class="el-icon-camera-solid"></i>考试全程监控中...
          <div class="img-corner">
            <span class="img-corner-corner img-corner-corner-0"></span>
            <span class="img-corner-corner img-corner-corner-1"></span>
            <span class="img-corner-corner img-corner-corner-2"></span>
            <span class="img-corner-corner img-corner-corner-3"></span>
          </div>
          <div class="page-record-video-focus">
            <img
              src="../assets/focus.png"
              alt
              class="page-record-video-focus-img"
              style="height: 450px;"
            />
          </div>
        </div>
        <canvas
          id="canvas1"
          height="500px"
          width="700px"
          style="display: none;"
        ></canvas>
        <div class="userInfo">
          <p>{{ from.name }}</p>
          <p>{{ from.idcard }}</p>
          <el-button type="danger" :disabled="disabledBtn" @click="submit"
            >提交</el-button
          >
        </div>
        <div class="discern" @click="dialogVisible = true">
          <i class="iconfont icon-wenhao"></i>
          <span style="cursor:pointer;"> 面部识别不出来</span>
        </div>
      </div>
      <el-dialog
        title="面部识别不出怎么办?"
        :visible.sync="dialogVisible"
        width="450px"
        center
      >
        <el-row class="text_center">
          <el-col :span="12">
            <img
              src="../assets/icon/ios-face-recognition.png"
              alt=""
              class="checkImg"
            /><br />
            <i class="iconfont icon-duigou-green"></i>请确定脸无遮挡
          </el-col>
          <el-col :span="12">
            <img src="../assets/icon/wifi.png" alt="" class="checkImg" /><br />
            <i class="iconfont icon-duigou-green"></i>请保持网络畅通
          </el-col>
        </el-row>
        <el-row class="text_center">
          <el-col :span="12">
            <img
              src="../assets/icon/browser-chrome.png"
              alt=""
              class="checkImg"
            /><br />
            <i class="iconfont icon-duigou-green"></i>请尝试重启浏览器
          </el-col>
          <el-col :span="12">
            <img
              src="../assets/icon/monitor-one.png"
              alt=""
              class="checkImg"
            /><br />
            <i class="iconfont icon-duigou-green"></i>请更换一台设备尝试
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
let mediaStreamTrack;
let video;
let canvas1;
let context1;
// var  navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
//     window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

let exArray = []; //存储设备源ID

export default {
  name: "Verify",
  data() {
    return {
      dialogVisible: false,
      from: {
        name: "",
        idcard: "",
        image: "",
        id: this.$route.params.id,
      },
      disabledBtn: false,
    };
  },
  created() {
    if (!this.IsPC()) {
      this.$alert("请在电脑端打开", "", {
        confirmButtonText: "返回",
        callback: (action) => {
          window.history.go(-2);
        },
      });
      return;
    }
    this.init();
    this.$nextTick(() => {
      video = document.querySelector("video");
      canvas1 = document.getElementById("canvas1");
      context1 = canvas1.getContext("2d");
      this.getMedia();
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  methods: {
    init() {
      let _this = this;
      this.$http
        .post(process.env.VUE_APP_API_URL + "getruser")
        .then(function(data) {
          _this.disabledBtn = false;

          if (data.data.code == 200) {
            _this.from.name = data.data.data.name;
            _this.from.idcard = data.data.data.idcard;
            _this.getMedia();
          } else {
            _this.$alert(data.data.msg, "", {
              confirmButtonText: "返回",
              callback: (action) => {
                window.history.go(-2);
              },
            });

            return;
          }
        })
        .catch(function(error) {
          _this.disabledBtn = false;

          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    getMedia() {
      let _this = this;
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia;
      if (navigator.getUserMedia) {
        navigator.getUserMedia(
          {
            video: {
              optional: [
                {
                  sourceId: exArray[0], //0为前置摄像头，1为后置
                },
              ],
            },
            audio: false,
          },
          function(stream) {
            mediaStreamTrack = stream;
            if (video.mozSrcObject !== undefined) {
              //Firefox中，video.mozSrcObject最初为null，而不是未定义的，我们可以靠这个来检测Firefox的支持
              video.mozSrcObject = stream;
            } else {
              try {
                video.srcObject = stream;
              } catch (error) {
                video.src = window.URL.createObjectURL(stream);
              }
            }
          },
          function(e) {
            console.log(e);
            // this.$message.warning('Error！'+e);
            _this.$message.warning("验证失败,请联系管理员");
          }
        ); //success是获取成功的回调函数
      } else {
        _this.$message.warning("请检查摄像头");
        return;
      }
    },
    getPhoto() {
      context1.drawImage(video, 0, 0);
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    submit() {
      let _this = this;
      if (!this.from.name) {
        _this.$message.error("请填写真实姓名");
        return;
      }
      if (!this.from.idcard) {
        _this.$message.error("请填写身份证号");
        return;
      }
      this.getPhoto();
      let imgData = document.getElementById("canvas1").toDataURL("image/png");
      let base64Data = imgData.replace(/^data:image\/\w+;base64,/, "");
      this.from.image = base64Data;
      // document.getElementById("ba").src=imgData
      _this.Storage.setStorage("examuser", imgData);

      _this.disabledBtn = true;
      this.$http
        .post(process.env.VUE_APP_API_URL + "verify", this.from)
        .then(function(data) {
          _this.disabledBtn = false;

          if (data.data.code == 200) {
            _this.Storage.setStorage("exampath", data.data.data);
            _this.$router.push({
              name: "exam_wp",
              params: { id: _this.from.id },
            });
          } else {
            _this.Storage.setStorage("examuser", "");
            if (data.data.code == 222350) {
              _this.$message.error({ message: "公安网图片不存在或质量过低" });
            } else if (data.data.code == 222351) {
              _this.$message.error({
                message: "身份证号与姓名不匹配或该身份证号不存在",
              });
            } else if (data.data.code == 222352) {
              _this.$message.error({ message: "身份证名字格式错误" });
            } else if (data.data.code == 222353) {
              _this.$message.error({ message: "身份证号码格式错误" });
            } else if (data.data.code == 222354) {
              _this.$message.error({ message: "公安库里不存在此身份证号" });
            } else if (data.data.code == 222355) {
              _this.$message.error({
                message: "身份证号码正确，公安库里没有对应的照片",
              });
            } else if (data.data.code == 222356) {
              _this.$message.error({ message: "验证的人脸图片质量不符合要求" });
            } else if (data.data.code == 222360) {
              _this.$message.error({
                message: "身份证号码或名字非法（公安网校验不通过）",
              });
            } else if (data.data.code == 222361) {
              _this.$message.error({ message: "公安服务连接失败" });
            } else if (data.data.code == 216600) {
              _this.$message.error({ message: "输入身份证格式错误" });
            } else if (data.data.code == 216601) {
              _this.$message.error({ message: "身份证号和名字匹配失败" });
            } else if (data.data.code == 222356) {
              _this.$message.error({ message: "验证的人脸图片质量不符合要求" });
            } else if (data.data.code == 222022) {
              _this.$message.error({ message: "格式错误" });
            } else if (data.data.code == 222351) {
              _this.$message.error({ message: "身份证号与姓名不匹配" });
            } else if (data.data.code == 0) {
              _this.$message.error({ message: data.data.msg });
            } else {
              _this.$message.error({ message: "验证失败!请联系管理员" });
            }
          }
        })
        .catch(function(error) {
          _this.disabledBtn = false;

          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.outerbg {
  background: #333;
  height: 100%;
  width: 100%;
  margin: 0;
  padding-top: 1px;
}
.bg {
  width: 900px;
  margin: 0 auto;
  background-color: #fff;
  text-align: center;
  border-radius: 20px;
  position: relative;
  h2 {
    font-weight: 400;
    font-size: 18px;
    padding-top: 10px;
  }
  p {
    color: red;
    font-size: 14px;
    letter-spacing: 1px;
  }
}
.con {
  width: 500px;
  margin: 10px auto;
}
.page-record-video {
  height: 450px;
  width: 500px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.page-record-video-obj {
  display: block;
  margin: 0 auto;
  width: 500px;
  height: 500px;
  object-fit: cover;
}

.page-record-video-focus {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: transparent;
}

.page-record-video-focus-img {
  display: block;
}
.img-corner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
}

.img-corner-corner {
  display: block;
  position: absolute;
  z-index: 2;
  width: 20px;
  height: 20px;
  background: url(../assets/icon2.png) no-repeat;
  -moz-background-size: cover;
  background-size: cover;
}

.img-corner-corner-0 {
  left: 20px;
  top: 20px;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.img-corner-corner-1 {
  right: 20px;
  top: 20px;
}

.img-corner-corner-2 {
  left: 20px;
  bottom: 20px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.img-corner-corner-3 {
  right: 20px;
  bottom: 20px;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.userInfo {
  text-align: center;
  line-height: 20px;
  p {
    height: 20px;
    color: #000;
  }
  .el-button {
    margin: 10px 0 30px 0;
  }
}
.discern {
  color: #666;
  height: 20px;
  font-size: 13px;
  position: absolute;
  left: 10px;
  bottom: 10px;
  .icon-wenhao {
    font-size: 6px;
  }
}

.checkImg {
  height: 30px;
  width: 30px;
}
.text_center {
  text-align: center;
}

.icon-duigou-green {
  color: #32cd32;
  font-size: 8px;
}
.el-row {
  margin: 20px 0;
}
</style>
